import {Injectable, signal, inject} from '@angular/core';
import {Tools_aiConsoleService} from '@llm/service/tools_ai-console.service';

export interface ThemePalette {
  name: string;
  colors: {
    primary: string;
    accent: string;
    text: string;
    boxShadow: string;
  };
}

const THEMES: ThemePalette[] = [
  {
    name: 'blue',
    colors: {
      primary: '#2196F3',
      accent: '#FFC107',
      text: '#ffffff',
      boxShadow: '0 4px 14px 0 rgba(33, 150, 243, 0.39)',
    },
  },
  {
    name: 'violet',
    colors: {
      primary: '#673ab7',
      accent: '#8BC34A',
      text: '#ffffff',
      boxShadow: '0 4px 14px 0 rgba(103, 58, 183, 0.39)',
    },
  },
  {
    name: 'gradient',
    colors: {
      primary: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
      accent: '#FFFFFF',
      text: '#ffffff',
      boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(103, 58, 183, 0.4)',
    },
  },
];

@Injectable({
  providedIn: 'root',
})
export class ToolsAiThemeService {
  // Injeta o serviço de console personalizado.
  private _console = inject(Tools_aiConsoleService);

  public selectedTheme = signal<ThemePalette>(THEMES[0]);
  public availableThemes = signal<ThemePalette[]>(THEMES);

  constructor() {
    this._console.log('Serviço de Tema inicializado com a paleta personalizada.');
  }

  /**
   * Atualiza o tema selecionado.
   * A UI de configurações chamaria este método.
   * @param themeName O nome do tema a ser ativado.
   */
  public setTheme(themeName: string): void {
    const newTheme = this.availableThemes().find(t => t.name === themeName);
    if (newTheme) {
      this.selectedTheme.set(newTheme);
      this._console.log(`Tema alterado para: ${newTheme.name}`);
    } else {
      this._console.warn(`Tema com o nome "${themeName}" não encontrado.`);
    }
  }

  /**
   * Retorna a cor primária de um tema específico pelo nome.
   * @param themeName O nome do tema.
   * @returns A string da cor primária (ex: '#FFFFFF' ou um gradiente) ou undefined se o tema não for encontrado.
   */
  public getColorsByThemeName(themeName: string): ThemePalette {
    const theme = this.availableThemes().find(t => t.name === themeName);
    this._console.warn(`Tema alterado para: ${theme.name}`);
    if (!theme) {
      this._console.warn(`Tema com o nome "${themeName}" não foi encontrado ao buscar a cor primária.`);
      return this.availableThemes().find(t => t.name === 'gradient');
    }
    return theme;
  }
}
